import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const renewalPayCallback = (params, urlParams) => {
  return axios.request({
    url: '/om/renewalpayorder/renewalpaycallback' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const renewalPayOrder = (params, urlParams) => {
  return axios.request({
    url: '/om/renewalpayorder/renewalpayorder' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

